import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { Input, Row, Col, Checkbox } from "antd";
import { FormItem } from "Components/form";
import { DISPLAY_MODE } from "Constants";

export default function MarriedStatusInput({
  married,
  form,
  mode = DISPLAY_MODE.READ_ONLY,
  ...props
}) {
  const { setValue } = form;

  useEffect(() => {
    setValue("wifeScore", married ? 6 : 0);
  }, [married]);

  return (
    <Row gutter={16}>
      <Col
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Controller
          control={form.control}
          name="married"
          render={({ onChange, onBlur, value, name }) => (
            <Checkbox
              onBlur={onBlur}
              disabled={mode === DISPLAY_MODE.READ_ONLY}
              onChange={(e) => onChange(e.target.checked)}
              checked={value}
              name={name}
            />
          )}
        />
      </Col>
      <Col xs={12}>
        <FormItem label="Toplam">
          <Controller
            defaultValue={0}
            control={form.control}
            name="wifeScore"
            as={<Input readOnly />}
          />
        </FormItem>
      </Col>
    </Row>
  );
}
